import { useReducedMotion } from 'framer-motion';

const useSeasonsAnimation = () => {
  const shouldReduceMotion = useReducedMotion();
  const yPos = shouldReduceMotion ? 0 : 32;
  const staggerVal = shouldReduceMotion ? 0 : 0.09;

  const listVariants = {
    center: {
      opacity: 1,
      transition: {
        duration: 0.2,
        staggerChildren: staggerVal,
        delayChildren: 0.2,
      },
    },
  };

  const episodeVariants = {
    enter: {
      y: yPos,
      opacity: 0,
    },
    center: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.4,
        type: 'tween',
        ease: 'easeOut',
      },
    },
    exit: {
      y: yPos,
      opacity: 0,
      transition: {
        duration: 0.3,
        type: 'tween',
        ease: 'easeIn',
      },
    },
  };

  return {
    listVariants,
    episodeVariants,
  };
};

export default useSeasonsAnimation;
